import React, { useEffect, useRef, useState } from 'react';
import {
  getAutocompletePredictions,
  validatePostalCode,
  getUtilityLabels,
  getAllLabels,
} from '../../../utils/commonUtils';
import * as store from '../../../hooks/useStores';
import { useDebounce } from '../../../hooks/useDebounce';
import { observer } from 'mobx-react';
import './LocationPopup.scss';
import Input from '../../atoms/InputField/Input';
import Cookies from 'js-cookie';

let autocompleteService = null;

function LocationPopup({
  handleCloseModal,
  addScrollVisible,
  removeScrollVisible,
  postalCodeChangeFunction,
}) {
  // const postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;
  const utilityLabels = getUtilityLabels();
  const labels = getAllLabels();

  const { uiStore } = store.useUtilityUiStore();
  const appStore = store.useAppUiStore();
  const [predictions, setPredictions] = useState([]);
  const [selectedPredictions, setSelectedPredictions] = useState('');
  const [inputPostalCode, setInputPostalCode] = useState('');
  const [errorOnInput, setErrorOnInput] = useState(null);
  const locationPopupRef = useRef(null);

  useEffect(() => {
    autocompleteService = new window.google.maps.places.AutocompleteService();
  }, []);

  const debouncedOnChange = useDebounce(getPredictions, 200);

  // Handle input value change for postal code
  async function handlePostalInputChange(value) {
    setErrorOnInput(null);
    if (selectedPredictions) {
      setSelectedPredictions('');
      return;
    }
    debouncedOnChange(value);
    setInputPostalCode(value);
  }

  async function getPredictions(value) {
    if (!value) {
      setPredictions([]);
      setSelectedPredictions('');
      removeScrollVisible();
      // locationPopupRef.current.classList.remove('add_height');
      return;
    }
    try {
      const predictionsRes = (await getAutocompletePredictions(value, autocompleteService)) || [];
      // const filteredPredictions =
      //   predictionsRes.filter((prediction) =>
      //     postalCodeRegex.test(prediction.structured_formatting.main_text)
      //   ) || [];
      setPredictions(predictionsRes);
      addScrollVisible();
      // locationPopupRef.current.classList.add('add_height');
    } catch (error) {
      setPredictions([]);
    }
  }
  function showPredictionList() {
    return (
      <div className="prediction_container">
        <ul className="prediction_list">
          {predictions.map((prediction) => (
            <li
              key={prediction.place_id}
              tabIndex="0"
              className="predictions_list_item"
              onClick={() => fillSelectedPrediction(prediction)}
              onKeyDown={(e) => e.key === 'Enter' && fillSelectedPrediction(prediction)}>
              {prediction.structured_formatting.main_text}{' '}
              {prediction.structured_formatting.secondary_text}
            </li>
          ))}
        </ul>
        <span className="container_grow"></span>
      </div>
    );
  }

  function fillSelectedPrediction(selectedPrediction) {
    setSelectedPredictions(selectedPrediction);
    setInputPostalCode(selectedPrediction.description);
    setPredictions([]);
    removeScrollVisible();
    // locationPopupRef.current.classList.remove('add_height');
  }

  async function updateLocationCloseModal(selectedPredictionData) {
    let validPostal = { isValid: false };
    let postalCode = selectedPredictionData
      ? selectedPredictionData.structured_formatting.main_text
      : inputPostalCode;
    if (inputPostalCode.length >= 3) {
      validPostal = await validatePostalCode(postalCode.toUpperCase());
    }
    if (selectedPredictionData === '' && !validPostal.isValid) {
      setErrorOnInput(utilityLabels.userLocationModal.errorMessageInput);
      removeScrollVisible();
      // locationPopupRef.current.classList.remove('add_height');
    } else {
      Cookies.remove('selectedModel');
      if (
        appStore.uiStore.currentProvince &&
        validPostal.provinceCode !== appStore.uiStore.currentProvince
      ) {
        const title = utilityLabels.userLocationModal?.changePostalCodeModalTitle || '';
        const desc = utilityLabels.userLocationModal?.changePostalCodeModalDescription || '';
        const getModalObject = { title, desc, validPostal };
        postalCodeChangeFunction(getModalObject);
      } else {
        uiStore.updateLocationStored(validPostal);
        handleCloseModal('close');
        if (validPostal.provinceCode !== appStore.uiStore.currentProvince) {
          window.location.reload();
        } else {
          const event = new CustomEvent('locationUpdated', { detail: validPostal });
          window.dispatchEvent(event);
        }
      }
    }
    setPredictions([]);
  }

  function handlePopupClick(e) {
    e.stopPropagation();
    setPredictions([]);
  }
  return (
    <div
      className="location_popup"
      data-testid="location_popup"
      ref={locationPopupRef}
      onClick={handlePopupClick}>
      <div className="location_popup_text">
        <h2 className="location_popup_heading">
          {utilityLabels.userLocationModal.userLocationTitle}
        </h2>
        <p className="location_popup_subheading">
          {utilityLabels.userLocationModal.userLocationDescription}
        </p>
      </div>
      <div className="location_form">
        <Input
          type="text"
          label={utilityLabels.userLocationModal.postalCodeLabel}
          error={errorOnInput}
          onChangeCallback={handlePostalInputChange}
          inputId="postal_input"
          inputSelected={selectedPredictions.description}
          extClasses="grow_field"
        />

        {predictions.length ? showPredictionList() : null}

        <button
          type="button"
          className="pincode_submit"
          onClick={() => updateLocationCloseModal(selectedPredictions)}>
          {labels.common.next}
        </button>
      </div>
      <p className="disclaimer_text">{utilityLabels.userLocationModal.userLocationDisclaimer}</p>
    </div>
  );
}

export default observer(LocationPopup);
